import { render, staticRenderFns } from "./ActivixComment.vue?vue&type=template&id=216bc5ad&"
import script from "./ActivixComment.vue?vue&type=script&lang=js&"
export * from "./ActivixComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports